import(/* webpackMode: "eager" */ "/buildkite/builds/2128ou37s8rfq-1/groq/groq-console-deploy-console-prod/apps/console/src/app/global-error.tsx");
